// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"_1B-aG","mobileOnly":"_29F71"};